import React from 'react';

/**
 * Displays the institution bank account participants / staff should transfer to.
 * Same layout as CRM Lead Application payment screens.
 */
export default function TWBankAccountInfoCard({ bankAccountInfo, title = 'Transfer Funds To', className = '' }) {
  if (!bankAccountInfo?.accountNumber) return null;

  return (
    <div className={`border border-indigo-200 rounded-lg p-3 bg-indigo-50 ${className}`}>
      <div className="flex items-start gap-2">
        <svg className="h-5 w-5 text-indigo-600 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z" />
        </svg>
        <div className="flex-1 min-w-0">
          <h4 className="text-sm font-semibold text-indigo-900 mb-1">{title}</h4>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1 text-xs">
            <div>
              <span className="text-indigo-700">Bank:</span>{' '}
              <span className="font-medium text-indigo-900">{bankAccountInfo.bankName || '—'}</span>
            </div>
            <div>
              <span className="text-indigo-700">Branch:</span>{' '}
              <span className="font-medium text-indigo-900">{bankAccountInfo.branchName || '—'}</span>
            </div>
            <div>
              <span className="text-indigo-700">Account Name:</span>{' '}
              <span className="font-medium text-indigo-900">
                {bankAccountInfo.accountHolderName || bankAccountInfo.accountName || '—'}
              </span>
            </div>
            <div>
              <span className="text-indigo-700">Account No:</span>{' '}
              <span className="font-mono font-medium text-indigo-900">{bankAccountInfo.accountNumber}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
